"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createThingType = createThingType;

var _react = _interopRequireDefault(require("react"));

var _HtmlRender = require("../../../../react-static/components/HtmlRender");

var _Link = require("../../../../react-static/components/Link");

function createThingType(thingType) {
  var url = thingType.url;
  var name = url ? _react.default.createElement(_Link.Link, {
    to: url
  }, thingType.name) : thingType.name;
  return thingType.brief ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h3", null, name), _react.default.createElement(_HtmlRender.HtmlRender, {
    html: thingType.brief
  })) : _react.default.createElement("h3", null, name);
}